import { CardsCount } from "./components/CardCount";
import { InstallmentsReceived } from "./components/InstallmentsReceived";
import { MonthByMonthProfitChart } from "./components/MonthByMonthProfitChart";

export const PageDashboardBroker = () => {
  return (
    <>
      <CardsCount />

      <MonthByMonthProfitChart />

      <InstallmentsReceived />
    </>
  );
};
